export default {
    text: 'Rugby Data',
    path: '/rugby',
    icon: 'rugby.svg',
    permissions: {
        RDATA: 'READ'
    },
    children: [
        {
            text: 'Rugby Events',
            path: '/rugby/events',
            children: [],
            permissions: {
                RDATA: 'READ'
            }
        }
    ]
};
